import { Box, Grid } from '@mui/material';
import { leftMenuAtom, rightMenuAtom } from '_state/signature';
import SideMenu from 'components/side-menu';
import SignaturePreview from 'components/signaturePreview';
import { useRecoilState } from 'recoil';

const LeftArrow = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.3175 3.05994L6.4275 7.94994C5.85 8.52744 5.85 9.47244 6.4275 10.0499L11.3175 14.9399"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const RightArrow = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.68262 14.9401L11.5726 10.0501C12.1501 9.47256 12.1501 8.52756 11.5726 7.95006L6.68262 3.06006"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const TemplateBuilder = () => {
  const [leftMenu, setLeftMenu] = useRecoilState(leftMenuAtom);
  const [rightMenu, setRightMenu] = useRecoilState(rightMenuAtom);

  return (
    <>
      {/* <div className="row">
        <div className="col-md-4">
          <SideMenu />
        </div>
        <div className="col-md-8">
          <SignaturePreview />
        </div>
      </div> */}
      <Grid container>
        <Grid
          item
          xs={!leftMenu ? 0.01 : 3.5}
          sx={{
            transition: theme =>
              theme.transitions.create('all', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
              }),
            position: 'relative',
          }}
        >
          {leftMenu ? <SideMenu /> : ''}
          <Box
            position={'absolute'}
            width={16}
            height={28}
            sx={{ backgroundColor: '#ffffff', cursor: 'pointer' }}
            right={-16}
            top={32}
            onClick={() => {
              setLeftMenu(!leftMenu);
              if (rightMenu) setRightMenu(false);
            }}
          >
            {leftMenu ? <LeftArrow /> : <RightArrow />}
          </Box>
        </Grid>
        <Grid
          item
          xs={leftMenu || rightMenu ? 8.48 : 11.98}
          // xs={leftMenu && rightMenu ? 5.98 : leftMenu || rightMenu ? 8.99 : 11.98}
          sx={{
            transition: theme =>
              theme.transitions.create('all', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
              }),
          }}
        >
          <SignaturePreview />
        </Grid>
        <Grid
          item
          xs={!rightMenu ? 0.01 : 3.5}
          sx={{
            transition: theme =>
              theme.transitions.create('all', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
              }),
            position: 'relative',
          }}
        >
          {rightMenu ? <SideMenu /> : ''}
          <Box
            position={'absolute'}
            width={16}
            height={28}
            sx={{ backgroundColor: '#ffffff', cursor: 'pointer' }}
            left={-16}
            top={32}
            onClick={() => {
              setRightMenu(!rightMenu);
              if (leftMenu) setLeftMenu(false);
            }}
          >
            {rightMenu ? <RightArrow /> : <LeftArrow />}
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default TemplateBuilder;
